import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const GroupLine: FC<IIconsProps> = ({
  color,
  size = IconScale.S,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.33325 14.666C1.33325 11.7205 3.72107 9.33268 6.66659 9.33268C9.61212 9.33268 11.9999 11.7205 11.9999 14.666H10.6666C10.6666 12.4569 8.87572 10.666 6.66659 10.666C4.45745 10.666 2.66659 12.4569 2.66659 14.666H1.33325ZM6.66659 8.66602C4.45659 8.66602 2.66659 6.87602 2.66659 4.66602C2.66659 2.45602 4.45659 0.666016 6.66659 0.666016C8.87659 0.666016 10.6666 2.45602 10.6666 4.66602C10.6666 6.87602 8.87659 8.66602 6.66659 8.66602ZM6.66659 7.33268C8.13992 7.33268 9.33325 6.13935 9.33325 4.66602C9.33325 3.19268 8.13992 1.99935 6.66659 1.99935C5.19325 1.99935 3.99992 3.19268 3.99992 4.66602C3.99992 6.13935 5.19325 7.33268 6.66659 7.33268ZM12.1891 9.80122C14.0429 10.6367 15.3333 12.5007 15.3333 14.666H13.9999C13.9999 13.042 13.0321 11.6441 11.6418 11.0174L12.1891 9.80122ZM11.7307 2.27482C13.0629 2.82404 13.9999 4.13509 13.9999 5.66602C13.9999 7.57948 12.5361 9.14948 10.6666 9.31775V7.97575C11.7977 7.81415 12.6666 6.84202 12.6666 5.66602C12.6666 4.74558 12.1343 3.95004 11.3606 3.57025L11.7307 2.27482Z"
        fill={color}
      />
    </svg>
  );
};

export default GroupLine;
